import React from 'react';

/**
 * 鏈上位址、雜湊這類「一個字元都不能看錯」的字串,一律用等寬字體。
 *
 * 比例字體下 Base58 位址最容易看錯的是 0/O、1/l/I,而且每一列的字元寬度不同,
 * 上下兩列沒有對齊,肉眼比對兩個位址(例如確認名單裡是不是同一顆)特別吃力。
 * 等寬字體讓同位置的字元垂直對齊,掃一眼就看得出哪裡不一樣。
 *
 * 字體堆疊挑選:優先用系統內建、對 0/O 有區別度的等寬字（SF Mono / Menlo / Consolas),
 * 不引入 web font —— 後台不值得為了這個多一個字體請求。
 */
export const MONO_FONT =
  'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", "Courier New", monospace';

export default function MonoText({
  children,
  style,
}: {
  children: React.ReactNode;
  style?: React.CSSProperties;
}) {
  return <span style={{ fontFamily: MONO_FONT, ...style }}>{children}</span>;
}
